module.exports = __webpack_public_path__ + "img/jackpot-physical-btn.9532b4de.webp";